//Done by @script Logger
// import * as functions from "firebase-functions";
export const Logger = console;

export type DeepPartial<T> = T extends object ? {
    [P in keyof T]?: DeepPartial<T[P]>;
} : T;

export type PickRequired<T, K extends keyof T> = T & Required<Pick<T, K>>;